import { render, staticRenderFns } from "./QuoteInReviewStateCard.vue?vue&type=template&id=55a0da64&"
import script from "./QuoteInReviewStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteInReviewStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports